import {Drawer} from "@mui/material";
import {destroyModal, useModal} from "../../utils/modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleXmark, faClock, faFire} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import {TranslatedAttribute} from "../../../../utils";
import AllergenIcon from "../AllergenIcon";
import ProductForm from "../Product/ProductForm";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

const LABEL_STYLES = {
  new: 'bg-green-100 text-green-800',
  star: 'bg-amber-100 text-amber-800',
  chefs_suggestion: 'bg-purple-100 text-purple-800',
};

const ProductDetailModal = () => {
  const modal = useModal();
  const {locale, showProductOptions} = useSelector(state => state.app);
  const {t} = useTranslation();
  return (
    <>
      {
        <Drawer
          PaperProps={{
            sx: {
              backgroundColor: "transparent",
              boxShadow: 'none'
            }
          }}
          anchor={'bottom'}
          open={true}
          onClose={destroyModal}
        >

          <div className={'w-full max-w-[420px] mx-auto bg-[#fff] h-full rounded-t-[30px] p-4 relative'}>
            <FontAwesomeIcon icon={faCircleXmark} size={'2x'}
                             className={'text-[#152553] w-[40px] h-[40px] absolute'}
                             style={{right: 5, top: 5}}
                             onClick={destroyModal}/>
            <div
              className={'overflow-scroll no-scrollbar max-h-[540px] flex flex-col justify-start items-center mt-10 relative'}>
              <div className={'flex justify-center'}>
                <img src={require('../../assets/img/bottom-pattern.png')} alt="" width={160}
                     style={{rotate: '180deg'}}/>
              </div>

              <div className={'flex flex-row my-2'}>
                {
                  (modal.data.ingredient_tags).map(tag => {
                    return (
                      <AllergenIcon tag={tag}/>
                    )
                  })
                }
              </div>

              <div className={'w-full'}>

                <div className={'flex flex-col'}>
                  <span className={'font-bold text-xl'}>{TranslatedAttribute(locale, modal.data, 'name')}</span>
                  <span
                    className={'font-normal text-[18px] mb-2'}>{TranslatedAttribute(locale, modal?.data, 'description')}</span>
                  {modal.data.labels && modal.data.labels.length > 0 && (
                    <div className={'flex flex-row flex-wrap gap-1 mt-1 mb-2'}>
                      {modal.data.labels.map((label) => (
                        <span key={label} className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${LABEL_STYLES[label] || 'bg-gray-100 text-gray-700'}`}>
                          {t(`labels.${label}`)}
                        </span>
                      ))}
                    </div>
                  )}
                  {
                    modal.data.note && (
                      <div className={'bg-blue-100 px-2 py-0.5 rounded-xl text-md mb-2 w-fit text-xs leading-[1.3] pt-1'}>
                        {t('general.note')}: {TranslatedAttribute(locale, modal.data, 'note')}
                      </div>
                    )
                  }
                  {modal.data.calorie && (
                    <div className={'flex flex-row items-center gap-1 text-[12px] text-orange-500 mt-1'}>
                      <FontAwesomeIcon icon={faFire} className={'text-orange-400'}/>
                      <span>{modal.data.calorie} {t('general.calorie')}</span>
                    </div>
                  )}
                </div>
                {
                  showProductOptions &&
                  <ProductForm item={modal.data}/>
                }

                <div>
                  {
                    modal.data.preparation_time && (
                      <div className={'text-center flex items-center justify-center bg-[#f8f8f8] rounded-xl mt-4'}>
                        <span className={'m-2 text-sm'}>{modal.data.preparation_time} {t('general.minute')} </span>
                        <FontAwesomeIcon icon={faClock} className={'text-[#808080]'}/>
                      </div>
                    )
                  }

                </div>

              </div>

            </div>
          </div>
        </Drawer>
      }
    </>
  )
}

export default ProductDetailModal;